// extracted by mini-css-extract-plugin
export default {"window":"Modal_window__TpQR8","exit__button":"Modal_exit__button__9Am4t"};